import React from 'react';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import {
  SidebarFooter,
  BackToMapButton,
  DirectionsButton,
  InterestedButton,
  InterestCounter,
  LastUpdateInfo,
  ButtonIcon,
  ButtonText
} from '../styles/EventSidebar.styles';

const EventFooter = ({ 
  event, 
  onClose, 
  isInterested, 
  interestCount, 
  isLoading, 
  onInterestToggle 
}) => {
  return (
    <>
      <SidebarFooter>
        <InterestedButton
          isInterested={isInterested}
          onClick={onInterestToggle}
          disabled={isLoading}
          title={isInterested ? "Non mi interessa più" : "Mi interessa"} // Tooltip per mobile
        >
          <ButtonIcon className="button-icon">
            {isLoading ? "⏳" : isInterested ? "❤️" : "🤍"}
          </ButtonIcon>
          <ButtonText className="button-text">
            {isLoading ? "Attendere..." : isInterested ? "Ti interessa" : "Mi interessa"}
          </ButtonText>
          {interestCount > 0 && <InterestCounter>{interestCount}</InterestCounter>}
        </InterestedButton>

        {event.location && (
          <DirectionsButton
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(event.location + (event.city ? ', ' + event.city : ''))}`}
            target="_blank"
            rel="noopener noreferrer"
            title="🗺️ Ottieni indicazioni"
          >
            <ButtonIcon className="button-icon">
              {/* ⬇️ SOSTITUISCI questa parte con l'SVG mappa */}
              <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '18px', height: '18px', color: '#4285f4' }}>
                <path d="M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"/>
              </svg>
            </ButtonIcon>
            <ButtonText className="button-text">Ottieni indicazioni</ButtonText>
          </DirectionsButton>

        )}

        <BackToMapButton 
          onClick={onClose}
          title="Chiudi dettagli evento"
        >
          <ButtonIcon className="button-icon">
            <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '20px', height: '20px' }}>
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </ButtonIcon>
          <ButtonText className="button-text">Chiudi</ButtonText>
        </BackToMapButton>

      </SidebarFooter>

      
    </>
  );
};

export default EventFooter;
